// @view/document/review/NewSectionModalVisible.view.tsx
import React from "react";
import * as styles from "@styles/SectionModal.css";

import { ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";
import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";
import SectionTitleErrorPanel from "@view/panels/document/review/SectionTitleError.panel";

type NewSectionModalVisibleViewProps = Pick<
  DocumentReviewViewProps,
  | "closeModal"
  | "newSectionTitle"
  | "setNewSectionTitle"
  | "handleSubmitNewSection"
  | "sectionTitleErrorPhase"
  | "sectionTitleErrorMessage"
>;

const NewSectionModalVisibleView: React.FC<NewSectionModalVisibleViewProps> = ({
  closeModal,
  newSectionTitle,
  setNewSectionTitle,
  handleSubmitNewSection,
  sectionTitleErrorPhase,
  sectionTitleErrorMessage,
}) => {
  return (
    <div
      className={styles.modalContainer}
      role="dialog"
      aria-modal="true"
      data-testid="review-new-section-modal"
    >
      <div className={styles.modalContent}>
        <p className={styles.modalTitle} data-testid="review-new-section-modal-title">
          Enter Section Details
        </p>
        <div className={styles.modalInnerContainer}>
          <input
            className={styles.textInput}
            data-testid="review-new-section-input"
            placeholder="Enter section title..."
            value={newSectionTitle}
            onChange={(event) => IO.run(setNewSectionTitle(event.target.value))}
          />
          <SectionTitleErrorPanel
            phase={sectionTitleErrorPhase}
            message={sectionTitleErrorMessage}
          />
          <div className={styles.btnContainer}>
            <button
              className={styles.addButton}
              data-testid="review-new-section-submit"
              onClick={() => {
                IO.run(handleSubmitNewSection(ok));
              }}
            >
              Add
            </button>
            <button
              className={styles.cancelButton}
              data-testid="review-new-section-cancel"
              onClick={() => IO.run(closeModal(ok))}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSectionModalVisibleView;
